import { LoanApplicationMode } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/types/LoanApplicationMode';
import { APP_ROLES } from '@/config/config';
import { useUserContext } from '@/contexts/UserContext/UserContext';

export const useLoanApplicationMode = () => {
  const { userEntity } = useUserContext();
  const role = userEntity?.role;

  const getLoanApplicationModeByRole = () => {
    if (!role) return LoanApplicationMode.VIEW_ONLY;

    switch (role) {
      case APP_ROLES.SUPER_ADMIN:
      case APP_ROLES.ADMIN:
      case APP_ROLES.MERCHANT_GROUP:
      case APP_ROLES.LENDER:
        return LoanApplicationMode.FULL;
      case APP_ROLES.CPC_BACK_OFFICE:
        return LoanApplicationMode.EDIT_CONTRACT_SIGNATURE_AND_ID;
      default:
        return LoanApplicationMode.VIEW_ONLY;
    }
  };
  return { getLoanApplicationModeByRole };
};
